export default "__VITE_ASSET__C2JBlOUk__"